import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-header__logo" }
const _hoisted_2 = {
  key: 0,
  class: "plan-mobile"
}
const _hoisted_3 = {
  key: 0,
  class: "plan"
}
const _hoisted_4 = { class: "plan__text" }
const _hoisted_5 = {
  key: 1,
  class: "plan"
}
const _hoisted_6 = { class: "plan__text" }
const _hoisted_7 = {
  key: 0,
  class: "plan__text"
}
const _hoisted_8 = { class: "limits-data__text" }
const _hoisted_9 = { class: "limits-data__text" }
const _hoisted_10 = {
  key: 2,
  class: "plan__text"
}

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import moment from 'moment';

import { useAuthStore } from '@/store/auth';
import { useCommonStore } from '@/store/common';

import AiCountdown from '@/components/UI/AiCountdown/AiCountdown.vue';

import MultiMenu from '@/components/common/MultiMenu/MultiMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const { plan, isAvailable } = storeToRefs(useAuthStore());

const { isMobile } = storeToRefs(useCommonStore());

const time = computed(() => {
  const currentDate = moment();
  const userExpDate = moment.utc(plan.value?.expiresAt).local();
  return userExpDate.diff(currentDate);
});

const daysLeft = computed(() => {
  const currentDate = moment();
  const expiresAt = moment.utc(plan.value?.expiresAt, 'YYYY-MM-DD HH:mm:ss');

  const diffInDays = expiresAt.diff(currentDate, 'days');
  return diffInDays + 1;
});

const daysQn = computed(() => {
  const connectedAt = moment.utc(plan.value?.connectedAt, 'YYYY-MM-DD HH:mm:ss');
  const expiresAt = moment.utc(plan.value?.expiresAt, 'YYYY-MM-DD HH:mm:ss');
  const diffInDays = expiresAt.diff(connectedAt, 'days');
  return diffInDays;
});

const endHandler = (): void => {
  isAvailable.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["app-header d-flex align-center justify-space-between", { 'app-header--mobile': _unref(isMobile) }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_inline_svg, {
          src: require('@/assets/icons/IconAILogoWhite.svg')
        }, null, 8, ["src"])
      ]),
      _createVNode(MultiMenu)
    ], 2),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(plan)?.name === 'Пробный')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('subscriptions.to-plan-end')), 1),
                _createVNode(AiCountdown, {
                  time: time.value,
                  onEnd: endHandler
                }, null, 8, ["time"])
              ]))
            : (_unref(plan)?.name === 'Безлимитный на 30 дней')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.left')), 1),
                  _createTextVNode(" " + _toDisplayString(daysLeft.value) + " ", 1),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('common.from')), 1))
                    : _createCommentVNode("", true),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(daysQn.value), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('common.d')) + ". ", 1),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "limits-data__divider" }, " / ", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(plan).name), 1),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('profile.plan-text')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})